import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';

import { LinkContainer } from './styles';
import { FiMoreVertical, FiPlusCircle } from 'react-icons/fi';

const CasterNavigation = ({ collapsed }) => {
	const [selectedKeys, setSelectedKeys] = useState(['dash']);

	const renderMenuTitle = useCallback(
		(title, Icon, to) =>
			to ? (
				<Link to={to}>
					{collapsed ? (
						<>
							<Icon style={{ fontSize: 18, marginBottom: -4 }} />
						</>
					) : (
						<LinkContainer>
							<Icon /> {title}
						</LinkContainer>
					)}
				</Link>
			) : collapsed ? (
				<>
					<Icon style={{ fontSize: 18, marginBottom: -4 }} />
				</>
			) : (
				<LinkContainer>
					<Icon /> {title}
				</LinkContainer>
			),
		[collapsed]
	);

	return (
		<Menu
			theme='dark'
			mode='inline'
			style={{ border: 'none' }}
			selectedKeys={selectedKeys}
			onSelect={({ key }) => setSelectedKeys([key])}
		>
			<Menu.Item key='track-presentations'>
				{renderMenuTitle('Apresentações M.', FiMoreVertical, '/commom/track-presentations')}
			</Menu.Item>

			<Menu.Item key='create-track-presentations'>
				{renderMenuTitle('Criar Apresentações', FiPlusCircle, '/commom/track-presentations/create')}
			</Menu.Item>
		</Menu>
	);
};

export default CasterNavigation;
